


















import { defineComponent, computed } from "@vue/composition-api";
import { useVuex } from "@/hooks/use-vuex";

export default defineComponent({
  setup() {
    const {
      store: { state, commit }
    } = useVuex();

    const drawerOpen = computed({
      get: () => state.NavBar.drawerOpen,
      set: (value: boolean) => commit.NavBar.setDrawer({ value })
    });

    const notifications = computed(() => {
      const items = state.Notifications.notifications;
      return !drawerOpen.value ? [...items].reverse().slice(0, 30) : [];
    });
    const dismiss = commit.Notifications.dismiss;

    return {
      drawerOpen,
      notifications,
      dismiss
    };
  }
});
